<template>
  <ContentGroup>
    <BlockGroup inline>
      <Block
        label="Telephone"
        no-border
      >
        <InputBox
          label="Telephone"
          prop="telephone"
          :required="!data.warning['telephone']"
          :edata="data.newProfile['telephone']"
          @input="methods.inputHandler"
        />
      </Block>

      <Block
        label="availableTime"
        no-border
      >
        <InputBox
          label="ช่วงเวลาที่ติดต่อได้"
          prop="availableTime"
          :edata="data.newProfile['availableTime']"
          @input="methods.inputHandler"
        />
      </Block>
    </BlockGroup>

    <BlockGroup inline>
      <Block
        label="Email"
        no-border
      >
        <InputBox
          label="Email"
          prop="email"
          :required="!data.warning['email']"
          :edata="data.newProfile['email']"
          @input="methods.inputHandler"
        />
      </Block>
    </BlockGroup>
  </ContentGroup>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import ContentGroup from "@/components/common-ui/content-group/index.vue";
import BlockGroup from "@/components/common-ui/block-group/index.vue";
import Block from "@/components/common-ui/block/index.vue";
import InputBox from "@/components/common-ui/forms/input-box/index.vue";
import data from "../data";

export default {
  components: {
    ContentGroup,
    BlockGroup,
    Block,
    InputBox
  },
  data() {
    return {
      ...data
    }
  },
  props: {
    methods: Object,
  }
}
</script>
